export default "__VITE_ASSET__yqE4_LQw__"